<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"><h5 class="mb-0">Sitios TEP</h5></div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">TEP</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Sitios</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="btn-group float-right">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-if="$store.getters.can('tep.sitios.create')"
                    @click="abrirModalCrear()"
                    data-toggle="modal"
                    data-target="#modal-tep-sitio"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-3">
                    <label>Nombre</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.nombre"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Sigla</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.sigla"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Bloque</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="bloqueFiltro"
                      label="nombre"
                      :options="listasForms.bloques"
                      @input="onBloqueFiltroChange"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Estado</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-2 pt-4 text-right">
                    <div class="btn-group">
                      <button class="btn bg-navy btn-sm" @click="getIndex()">
                        <i class="fas fa-search"></i>
                      </button>
                      <button class="btn btn-danger btn-sm" @click="limpiar()">
                        <i class="fas fa-broom"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body table-responsive p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm text-center align-middle"
                >
                  <thead class="bg-dark">
                    <tr>
                      <th>Nombre</th>
                      <th>Código</th>
                      <th>Sigla</th>
                      <th>Bloque</th>
                      <th>Estado</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sitio in sitios.data" :key="sitio.id">
                      <td>{{ sitio.nombre }}</td>
                      <td>{{ sitio.codigo }}</td>
                      <td>{{ sitio.sigla }}</td>
                      <td>
                        <span v-for="bloque in sitio.bloques" :key="bloque.id">
                          <span class="badge bg-navy">{{ bloque.nombre }}</span>
                          <br />
                        </span>
                      </td>
                      <td>
                        <span
                          class="badge"
                          :class="
                            sitio.estado == 1 ? 'badge-success' : 'badge-danger'
                          "
                        >
                          {{ sitio.nEstado }}
                        </span>
                      </td>
                      <td>
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="$store.getters.can('tep.sitios.show')"
                            @click="abrirModalEditar(sitio.id)"
                            data-toggle="modal"
                            data-target="#modal-tep-sitio"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="$store.getters.can('tep.sitios.delete')"
                            @click="destroy(sitio.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer">
                <div class="float-left" v-if="sitios.total">
                  Mostrando del <b>{{ sitios.from }}</b> al
                  <b>{{ sitios.to }}</b> de <b>{{ sitios.total }}</b> registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger"
                    >No hay registros para mostrar</span
                  >
                </div>
                <pagination
                  :data="sitios"
                  @pagination-change-page="getIndex"
                  :limit="3"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal-tep-sitio"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h5 class="modal-title text-white">
              {{ gestion.id ? "Editar sitio" : "Crear sitio" }}
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0 pt-1">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-datos"
                  data-toggle="tab"
                  href="#datos"
                  >Datos</a
                >
              </li>
              <li class="nav-item" v-if="gestion.id">
                <a
                  class="nav-link"
                  id="tab-geocerca"
                  data-toggle="tab"
                  href="#geocerca"
                  >Geocerca</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="datos">
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label>Nombre</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.nombre"
                        :class="
                          $v.gestion.nombre.$invalid ? 'is-invalid' : 'is-valid'
                        "
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Código</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.codigo"
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Sigla</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.sigla"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Bloque</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="[
                          $store.getters.getDarkMode ? 'dark-vselect' : '',
                          $v.gestion.bloques_ids.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                        ]"
                        v-model="bloques"
                        label="nombre"
                        :options="listasForms.bloques"
                        @input="onBloqueGestionChange"
                        multiple
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Ciudad</label>
                      <v-select
                        class="form-control form-control-sm p-0"
                        :class="[
                          $store.getters.getDarkMode ? 'dark-vselect' : '',
                          $v.gestion.ciudad_id.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                        ]"
                        v-model="ciudadGestion"
                        label="nombre"
                        :options="listasForms.ciudades"
                        @input="onCiudadGestionChange"
                      />
                    </div>
                    <div class="form-group col-md-5">
                      <label>Dirección</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="gestion.dirreccion"
                        :class="[
                          $v.gestion.dirreccion.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                        ]"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label>Estado</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="gestion.estado"
                        :class="[
                          $v.gestion.estado.$invalid
                            ? 'is-invalid'
                            : 'is-valid',
                        ]"
                      >
                        <option value="">Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados"
                          :key="estado.numeracion"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="geocerca" v-if="gestion.id">
                <div class="card-body">
                  <TepSitioGeocerca
                    :entity="gestion"
                    :estados="listasForms.estados"
                    @loading="cargando = $event"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary btn-sm" @click="guardarSitio()">
              <i class="fas fa-save"></i> Guardar
            </button>
            <button class="btn btn-secondary btn-sm" data-dismiss="modal">
              <i class="fas fa-times"></i> Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import pagination from "laravel-vue-pagination";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";
import TepSitioGeocerca from "./TepSitioGeocerca.vue";

export default {
  name: "TepSitioIndex",
  components: {
    Loading,
    pagination,
    vSelect,
    TepSitioGeocerca,
  },

  data() {
    return {
      cargando: false,
      tabModal: "datos",
      sitios: {},
      bloqueFiltro: null,
      ciudadGestion: null,
      bloques: [],
      gestion: {
        id: null,
        codigo: null,
        nombre: null,
        sigla: null,
        bloques_ids: [],
        ciudad_id: null,
        departamento_id: null,
        dirreccion: null,
        estado: 1,
      },
      filtros: {
        nombre: null,
        sigla: null,
        bloque_id: null,
        estado: null,
      },
      listasForms: {
        bloques: [],
        ciudades: [],
        estados: [],
      },
    };
  },

  validations: {
    gestion: {
      nombre: {
        required,
      },
      sigla: {
        required,
      },
      codigo: {
        required,
      },
      ciudad_id: {
        required,
      },
      departamento_id: {
        required,
      },
      dirreccion: {
        required,
      },
      estado: {
        required,
      },
      bloques_ids: {
        required: (value) =>
          !!(value && Array.isArray(value) && value.length > 0),
      },
    },
  },

  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/tep/sitios?page=" + page, { params: this.filtros })
        .then((response) => {
          this.sitios = response.data;
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },

    getBloques() {
      axios.get("/api/tep/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasForms.ciudades = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    onBloqueFiltroChange() {
      this.filtros.bloque_id = this.bloqueFiltro ? this.bloqueFiltro.id : null;
    },

    onBloqueGestionChange() {
      this.gestion.bloques_ids = [];
      if (this.bloques) {
        this.gestion.bloques_ids = this.bloques.map((b) => b.id);
      }
    },

    onCiudadGestionChange() {
      this.gestion.ciudad_id = this.ciudadGestion
        ? this.ciudadGestion.id
        : null;
      this.gestion.departamento_id = this.ciudadGestion
        ? this.ciudadGestion.departamento_id
        : null;
    },

    abrirModalCrear() {
      this.resetGestion();
      this.tabModal = "datos";
    },

    abrirModalEditar(id) {
      this.tabModal = "datos";
      this.cargando = true;
      axios
        .get("/api/tep/sitios/show/" + id)
        .then((response) => {
          const data = response.data;
          const bloquesArray = Array.isArray(data.bloques)
            ? data.bloques
            : data.bloque
            ? [data.bloque]
            : [];
          this.bloques = bloquesArray;
          this.gestion = {
            id: data.id,
            codigo: data.codigo,
            nombre: data.nombre,
            sigla: data.sigla,
            bloque_id: data.bloque_id,
            bloques_ids: bloquesArray.map((b) => b.id),
            ciudad_id: data.ciudad_id,
            departamento_id: data.departamento_id,
            dirreccion: data.dirreccion,
            estado: data.estado,
            geocerca: data.geocerca || null,
            latitud: data.latitud || null,
            longitud: data.longitud || null,
          };
          this.ciudadGestion = data.ciudad || null;
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },

    guardarSitio() {
      this.cargando = true;
      axios({
        method: this.gestion.id ? "PUT" : "POST",
        url: "/api/tep/sitios",
        data: this.gestion,
      })
        .then((response) => {
          const guardado = response.data || {};
          this.gestion.id = guardado.id || this.gestion.id;
          this.gestion.geocerca =
            guardado.geocerca || this.gestion.geocerca || null;
          this.getIndex();
          this.cargando = false;
          this.$swal({
            icon: "success",
            title: "Sitio guardado exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch(() => {
          this.cargando = false;
        });
    },

    resetGestion() {
      this.bloques = [];
      this.gestion = {
        id: null,
        codigo: null,
        nombre: null,
        sigla: null,
        bloque_id: null,
        bloques_ids: [],
        ciudad_id: null,
        departamento_id: null,
        dirreccion: null,
        estado: 1,
        geocerca: null,
        latitud: null,
        longitud: null,
      };
      this.ciudadGestion = null;
    },

    limpiar() {
      this.bloqueFiltro = null;
      this.filtros = {
        nombre: null,
        sigla: null,
        bloque_id: null,
        estado: null,
      };
      this.getIndex();
    },

    destroy(id) {
      this.$swal({
        title: "Esta seguro de eliminar el sitio?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.cargando = true;
          axios.delete("/api/tep/sitios/" + id).then(() => {
            this.getIndex();
            this.cargando = false;
          });
        }
      });
    },
  },
  mounted() {
    this.getBloques();
    this.getCiudades();
    this.getEstados();
    this.getIndex();
  },
};
</script>
